
var sprite = require("/tmp/build_27def88f/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol id=\"gift_icon_jax_f8017e70506911ed991ab87d157c1d37\" ><path d=\"M21.444 6.778H1v3.555h20.444V6.778zM20.555 10.333H1.89V21h18.666V10.333zM8.111 6.778V21M14.334 21V6.778\" stroke=\"#2CD4AE\" stroke-width=\"1.2\" stroke-miterlimit=\"10\" stroke-linejoin=\"round\"/><path d=\"M16.25 4.794c-.867.868-5.028 1.885-5.028 1.885s1.018-4.16 1.886-5.028a2.223 2.223 0 013.143 3.143zM6.194 4.794c.868.868 5.028 1.885 5.028 1.885s-1.018-4.16-1.885-5.028a2.223 2.223 0 00-3.143 3.143z\" stroke=\"#2CD4AE\" stroke-width=\"1.2\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></symbol>";
module.exports = sprite.add(image, "gift_icon_jax_f8017e70506911ed991ab87d157c1d37");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/gift_icon.svg
// module id = 1334
// module chunks = 1